// Components
import SimpleTable from '../SimpleTable/SimpleTable';

// Styles
import styles from './DashboardTable.module.css';
import cn from '../../../utils/cn';

/**
 * DashboardTable component - Renders a simple table for dashboards
 * Wrapper around SimpleTable with dashboard variant configuration
 * @param {object} props - Component props
 * @param {ApiDashboardItemTableTable} props.table - Table data
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element | null}
 */
function DashboardTable({ table, className }) {
  return (
    <div className={cn([styles['dashboard-table-wrapper'], className])}>
      <SimpleTable
        table={table}
        variant="dashboard"
        showEmptyMessage
        containerProps={{
          className: styles['dashboard-table-container'],
        }}
      />
    </div>
  );
}

export default DashboardTable;
